import { Observable, Observer } from 'rxjs';

import { createImageUrl } from '@shared/utils/object-mapper.util';

import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadFile, NzUploadXHRArgs } from 'ng-zorro-antd/upload';

export const beforeUploadFile = (file: NzUploadFile, messageService: NzMessageService): boolean | Observable<boolean> => {
  return new Observable((observer: Observer<boolean>) => {
    const isCSV = file.type === 'text/csv'

    if (!isCSV) {
      messageService.error('You can upload a CSV file!');
      observer.complete();
      return;
    }

  });
};

export const uploadFile = (item: NzUploadXHRArgs,fileService, messageService, fileLoading: boolean, callback) => {
  const formData = new FormData();

  formData.append('file', item.file as any);


  return fileService.uploadFile(formData).subscribe(response => {
    callback(createImageUrl(response.image));
    fileLoading = false;
    messageService.success('Upload successfully!');
  }, () => {
    fileLoading = false;
    messageService.error('Error while uploading image!');
  });
};
